import React from 'react';
import { FormImageFieldModal } from '../../../../media-management/components/form-image/FormImageFieldModal';
import { ElementWrapper } from '../../../components/ElementWrapper';
import { IElement } from '../../../models/Element';
import { PluginHeader } from './PluginHeader';
import { PluginHeaderContent } from './PluginHeaderContent';
import { PluginHeaderFigure } from './PluginHeaderFigure';

type Props = {
  index: number;
  data: PluginHeader;
  updateData: (element: IElement, index: number) => void;
};

export const PluginHeaderFC: React.FC<Props> = ({
  index,
  data,
  updateData,
}) => {
  const update = (fieldsToUpdate: Partial<PluginHeader>) => {
    const updatedData = { ...data, ...fieldsToUpdate };
    updateData(updatedData, index);
  };
  return (
    <>
      <FormImageFieldModal
        modalId={`${data.name}-${data.id}`}
        name={`image`}
        altText={`image_alt`}
        update={update}
      />

      <ElementWrapper elementIndex={index}>
        <div className="plugin-header">
          <div className="showcase">
            <PluginHeaderContent data={data} update={update} />
            <PluginHeaderFigure data={data} update={update} />
          </div>
        </div>
      </ElementWrapper>
    </>
  );
};
